import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "crumbs" }
const _hoisted_2 = { class: "content-wrap flex flex-between" }
const _hoisted_3 = { class: "text-gray" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "crumbs-item current"
}
const _hoisted_6 = { class: "crumbs-item current" }
const _hoisted_7 = ["href"]

import { HistoryState, RouteRecord, useRoute } from "vue-router";
import { computed, ref, watch, type PropType } from "vue";
import TaskProgress from "@/views/task/components/TaskProgress.vue";

// 定义面包屑类型
type CrumbType = 'route' | 'routeWithTask' | 'taskOnly';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainCrumb',
  props: {
  crumbs: {
    type: Object as PropType<RouteRecord[]>,
    default: [] as Array<RouteRecord>,
  },
  type: {
    type: String as PropType<CrumbType>,
    default: 'route' as CrumbType,
    validator: (value: string) => ['route', 'routeWithTask', 'taskOnly'].includes(value)
  },
  taskName: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const route = useRoute();
const props = __props;

const help = computed(() => {
  if (route.meta && route.meta.help) {
    return route.meta.help as { link: string, title: string };
  }
  return false;
});

const progress = computed(() => {
  if (route.meta && route.meta.progress) {
    return route.meta.progress as number;
  }
  return false;
})

const _history = ref(history.state) // 保存历史记录

const updateHistoryState = () => {
  console.log('???', history.state);
  _history.value = history.state;
};

// 获取任务名称
const getTaskName = (): string => {
  // 优先使用传入的taskName，其次使用history中的taskName
  if (props.taskName) {
    return props.taskName;
  }
  if (_history.value?.taskName) {
    return decodeURIComponent(_history.value.taskName);
  }
  if (route.params && route.params.taskName) {
    return decodeURIComponent(route.params.taskName as string);
  }
  return '';
};

// 判断是否应该显示任务名
const shouldShowTaskName = (): boolean => {
  const taskName = getTaskName();

  switch (props.type) {
    case 'route':
      return false;
    case 'routeWithTask':
      return !!taskName && !progress.value;
    case 'taskOnly':
      return true;
    default:
      return false;
  }
};

const handleToObj = (item: RouteRecord): HistoryState => {
  if (item.path.match(/:\w+/)) {
    return { name: item.name as string, params: route.params, state: _history.value };
  } else {
    return { name: item.name as string };
  }
};

watch(
  () => route.fullPath,
  () => {
    updateHistoryState();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode(" 当前位置： ")),
        (props.type === 'taskOnly')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "crumbs-item current task-name",
              title: getTaskName()
            }, _toDisplayString(getTaskName()), 9, _hoisted_4))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.crumbs, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (index != props.crumbs.length - 1 && item.meta?.title)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_router_link, {
                        class: "crumbs-item",
                        to: handleToObj(item)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.meta?.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _cache[0] || (_cache[0] = _createTextVNode(" / "))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (item.meta?.title)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.meta?.title), 1))
                        : _createCommentVNode("", true),
                      (shouldShowTaskName())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[1] || (_cache[1] = _createTextVNode(" / ")),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(getTaskName()), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 64))
            }), 128))
      ]),
      (progress.value)
        ? (_openBlock(), _createBlock(TaskProgress, {
            key: 0,
            current: progress.value
          }, null, 8, ["current"]))
        : _createCommentVNode("", true),
      (help.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            style: {"text-decoration":"underline"},
            href: help.value.link,
            target: "_blank"
          }, _toDisplayString(help.value.title), 9, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})